var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchDevice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 152,
    viewBox: "0 0 153 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.3391 119.081H39.6806C32.3081 119.081 26.325 113.104 26.325 105.726V38.954C26.325 31.5816 32.3081 25.5985 39.6806 25.5985H106.452C113.831 25.5985 119.808 31.5816 119.808 38.954V92.6126C122.167 92.9496 124.413 93.6354 126.489 94.6227V38.9542C126.489 27.8925 117.52 18.9243 106.453 18.9243H39.681C28.6194 18.9243 19.6512 27.8931 19.6512 38.9542V105.726C19.6512 116.793 28.62 125.762 39.681 125.762H95.3496C94.3622 123.687 93.6761 121.44 93.3391 119.081Z",
    fill: "#D3D4D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.689 119.194H121.231L120.714 118.695C122.523 116.591 123.612 113.859 123.612 110.886C123.612 104.259 118.24 98.8867 111.613 98.8867C104.985 98.8867 99.6129 104.259 99.6129 110.886C99.6129 117.514 104.985 122.886 111.613 122.886C114.585 122.886 117.317 121.797 119.422 119.988L119.92 120.505V121.963L129.15 131.175L131.901 128.424L122.689 119.194ZM111.613 119.194C107.016 119.194 103.305 115.483 103.305 110.886C103.305 106.29 107.016 102.579 111.613 102.579C116.209 102.579 119.92 106.29 119.92 110.886C119.92 115.483 116.209 119.194 111.613 119.194Z",
    fill: "#D3D4D8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDevice);
export default __webpack_public_path__ + "static/media/search-device.e52b2a772ac2361b4f17046d4fcad7e0.svg";
export { ForwardRef as ReactComponent };